type ResolvesToNotPepProps = {
  pep?: boolean;
  bloodRelatedToPep?: boolean;
  cicac?: boolean;
  pepLawArticle?: boolean;
};

export function resolvesToNotPep({
  pep,
  bloodRelatedToPep,
  cicac,
  pepLawArticle,
}: ResolvesToNotPepProps): boolean {
  const onlyPepAndBloodRelated =
    typeof pep !== 'undefined' &&
    typeof bloodRelatedToPep !== 'undefined' &&
    typeof cicac === 'undefined' &&
    typeof pepLawArticle === 'undefined';

  // Si solo se envían `pep` y `bloodRelatedToPep`, compara solo esos dos
  if (onlyPepAndBloodRelated) {
    return !pep && !bloodRelatedToPep;
  }

  return (
    typeof pep !== 'undefined' &&
    typeof bloodRelatedToPep !== 'undefined' &&
    typeof pepLawArticle !== 'undefined' &&
    !pep &&
    !bloodRelatedToPep &&
    !pepLawArticle &&
    !cicac
  );
}

export default resolvesToNotPep;
